module.exports = __webpack_public_path__ + "static/m_solution1-de5767a26fa66a135984fe6662e6cfdd.png";